import React, { useState, useEffect } from 'react';
import { FaCheck, FaClipboard, FaTimes } from 'react-icons/fa';
import '../../src/widthrawRequest.css';
import { fetchWidthrawRequest } from '../api/widthtrawRequestApi';
import { approveWidthrawRequest } from '../api/widthtrawRequestApi';
import { Button, Box, Typography } from '@mui/material';
import InboxIcon from '@mui/icons-material/Inbox';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';

const Modal = ({ isOpen, onClose, onConfirm, id }) => {
  if (!isOpen) return null;

  return (
    <div style={modalOverlayStyle}>
      <div style={modalStyle}>
        <h3>Are you sure you want to approve this withdrawal request?</h3>
        <p>If you approve, the request will be processed. Do you want to continue?</p>
        <div>
          <button onClick={() => onConfirm(id)} style={{ background: 'green', color: 'white', marginRight: '10px' }}>
            Confirm
          </button>
          <button onClick={onClose} style={{ background: 'gray', color: 'white' }}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

const WithdrawRequest = () => {
  const [withdrawRequests, setWithdrawRequests] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [requestIdToApprove, setRequestIdToApprove] = useState(null);
  const [requestToApproveData, setRequestToApproveData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const loadWidthrawRequest = async () => {
      try {
        const data = await fetchWidthrawRequest();
        console.log(data, "data");
        setWithdrawRequests(data.data.data);
      } catch (error) {
        console.error('Failed to fetch withdraw requests:', error);
      }
    };

    loadWidthrawRequest();

  }, []);

  const handleApprove = (request) => {
    setRequestToApproveData(request);
    setRequestIdToApprove(request.id);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setRequestIdToApprove(null);
    setRequestToApproveData(null);
  };

  const handleBackClick = () => {
    navigate('/dashboard');
  };

  const handleConfirmApprove = async () => {
    console.log(requestToApproveData, "requestToApproveData")
    if (!requestToApproveData) return;

    try {
      const response = await approveWidthrawRequest({
        id: requestToApproveData.id,
        user_id: requestToApproveData.user_id,
        amount: parseFloat(requestToApproveData.amount),
        transaction_id: requestToApproveData.transaction_id
      });
      if (response.data.status === 200) {

        setWithdrawRequests(prevRequests =>
          prevRequests.filter(request => request.id !== requestToApproveData.id)
        );
      } else {
        alert(`Failed to approve request with ID: ${requestToApproveData.id}`);
      }
    } catch (error) {
      console.error('Error during approval:', error);
    }

    setIsModalOpen(false);
    setRequestIdToApprove(null);
    setRequestToApproveData(null);
  };

  const handleDownloadCSV = () => {
    const header = [
      'ID', 'User ID', 'User Name', 'Amount', 'Net Payable', 'To be Diduceted', 'Method', 'Status', 'Requested At', 'Transaction ID', 'Ifsc_code', 'Account No'
    ];

    const rows = withdrawRequests.map(request => [
      request.id,
      request.user_id,
      request.bankDetails.beneficiary_name,
      request.amount,
      request.netPayable,
      request.tobeDiducted,
      request.method,
      request.status,
      formatDate(request.requested_at),
      request.transaction_id,
      request.bankDetails.ifsc_code,
      request.bankDetails.account_number
    ]);

    const csvContent = [
      header.join(','),
      ...rows.map(row => row.join(','))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', 'withdraw_requests.csv');
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleDownloadExcel = () => {
    const header = [
      'ID', 'User ID', 'User Name', 'Amount', 'Net Payable', 'To be Diduceted', 'Method', 'Status', 'Requested At', 'Transaction ID', 'IFSC Code', 'Account No'
    ];

    const rows = withdrawRequests.map(request => [
      request.id,
      request.user_id,
      request.bankDetails.beneficiary_name,
      request.amount,
      request.netPayable,
      request.tobeDiducted,
      request.method,
      request.status,
      formatDate(request.requested_at),
      request.transaction_id,
      request.bankDetails.ifsc_code,
      request.bankDetails.account_number
    ]);

    // Combine header and rows
    const data = [header, ...rows];

    // Create a worksheet and workbook
    const worksheet = XLSX.utils.aoa_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Withdraw Requests');

    // Generate Excel file and download
    XLSX.writeFile(workbook, 'withdraw_requests.xlsx');
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    if (isNaN(date)) {
      return 'Invalid Date';
    }

    const options = {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    };

    return date.toLocaleString('en-GB', options).replace(',', '');
  };

  const handleCopyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      alert('Copied to clipboard!');
    }).catch(err => {
      console.error('Failed to copy text: ', err);
    });
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2>Withdrawal Requests</h2>
      <Button
        variant="contained"
        color="secondary"
        onClick={handleBackClick}
        sx={{ marginBottom: 2 }}
      >
        Back to Dashboard
      </Button>
      {/* Download Button */}
      <Button
        variant="contained"
        color="primary"
        onClick={handleDownloadCSV}
        sx={{ marginBottom: 2, marginLeft: 5 }}
      >
        Download CSV
      </Button>

      <Button
        variant="contained"
        color="primary"
        onClick={handleDownloadExcel}
        sx={{ marginBottom: 2, marginLeft: 5 }}
      >
        Download Excel
      </Button>
      {withdrawRequests.length === 0 ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 6,
            color: 'text.secondary',
          }}
        >
          <InboxIcon sx={{ fontSize: 96, color: 'grey.400', mb: 2 }} />
          <Typography variant="h6" gutterBottom>
            No Withdrawal Requests
          </Typography>
          <Typography variant="body2">
            No data available to display at the moment.
          </Typography>
        </Box>
      ) : (
      <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
        <thead>
          <tr>
            <th>ID</th>
            <th>User ID</th>
            <th>User Name</th>
            <th>Amount</th>
            <th>Net Payable</th>
            <th>To be Diduceted</th>
            <th>Method</th>
            <th>Status</th>
            <th>Requested At</th>
            <th>Transaction ID</th>
            <th>Ifsc_code</th>
            <th>Account No</th>

            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {withdrawRequests.map((request) => (
            <tr key={request.id}>
              <td>{request.id}</td>
              <td>{request.user_id}</td>
              <td>{request.bankDetails.beneficiary_name}</td>
              <td>{request.amount}</td>
              <td>{request.netPayable}</td>
              <td>{request.tobeDiducted}</td>
              <td>{request.method}</td>
              <td>{request.status}</td>
              <td>{formatDate(request.requested_at)}</td>
              <td>{request.transaction_id}</td>
              <td>{request.bankDetails.ifsc_code}
                <button
                  onClick={() => handleCopyToClipboard(request.bankDetails.ifsc_code)}
                  style={{ marginLeft: '5px', cursor: 'pointer' }}
                > <FaClipboard />
                </button>
              </td>
              <td>{request.bankDetails.account_number}
                <button
                  onClick={() => handleCopyToClipboard(request.bankDetails.account_number)}
                  style={{ marginLeft: '5px', cursor: 'pointer' }}
                > <FaClipboard />
                </button>
              </td>
              <td>
                <button
                  onClick={() => handleApprove(request)}
                  style={{ background: 'green', color: 'white', marginRight: '10px' }}
                >
                  <FaCheck />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      )}

      <Modal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleConfirmApprove}
        id={requestIdToApprove}
      />
    </div>
  );
};

const modalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
};

const modalStyle = {
  background: 'white',
  padding: '20px',
  borderRadius: '8px',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  width: '400px',
  textAlign: 'center',
};

export default WithdrawRequest;
